import { render, staticRenderFns } from "./PartitionValidationErrors.vue?vue&type=template&id=fbff5d16&scoped=true"
import script from "./PartitionValidationErrors.vue?vue&type=script&lang=js"
export * from "./PartitionValidationErrors.vue?vue&type=script&lang=js"
import style0 from "./PartitionValidationErrors.vue?vue&type=style&index=0&id=fbff5d16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff5d16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbff5d16')) {
      api.createRecord('fbff5d16', component.options)
    } else {
      api.reload('fbff5d16', component.options)
    }
    module.hot.accept("./PartitionValidationErrors.vue?vue&type=template&id=fbff5d16&scoped=true", function () {
      api.rerender('fbff5d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/PartitionValidationErrors.vue"
export default component.exports